import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Paper,
  Tabs,
  Tab,
  CircularProgress,
  useMediaQuery,
  Skeleton,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../redux/slices/common.slice";
import { getDashboardMessages } from "../../../redux/slices/dashboard.slice";
import CreateMessages from "../settings/Project/createMessage";
import moment from "moment";

export default function Messages() {
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState();
  const [selectedMessage, setSelectedMessage] = useState();
  const [messageOpen, setMessageOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:610px)");
  const dispatch = useDispatch();

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setMessages([]);
    setLoading(true);
  };

  const fetchMessages = async () => {
    setLoading(true);

    let response = await dispatch(
      getDashboardMessages({
        type: activeTab === 0 ? "scheduled" : "on_demand",
      })
    );
    const { payload } = response;

    if (payload?.status) {
      setMessages(payload?.data);
    } else {
      dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: payload?.message || "Internal server error",
        })
      );
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchMessages();
  }, [activeTab]);
  return (
    <>
      <Paper elevation={3} sx={{ padding: "8px" }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="TODO tabs"
          className="configure-action-tab"
        >
          <Tab label={"Scheduled Messages"} disabled={loading} />
          <Tab label={"On Demand Messages"} disabled={loading} />
        </Tabs>
        <Box
          sx={{
            height: "calc(100vh - 230px)",
            overflowY: "auto",
            position: "relative",
          }}
        >
          {!loading && messages && messages?.length > 0 && (
            <Grid container spacing={2} sx={{ p: 2 }}>
              {messages?.map((message) => (
                <Grid item xs={12} sm={6} lg={6} md={6} xl={4} key={message.id}>
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",

                      "&:hover": { boxShadow: 3 },
                    }}
                    onClick={() => {
                      setMessageOpen(true);
                      setSelectedMessage(message);
                    }}
                  >
                    <CardContent
                      sx={{
                        flexGrow: 1,
                        position: "relative",
                        padding: 2,
                        backgroundColor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 3,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        paddingBottom: "16px !important",
                      }}
                    >
                      {/* Project Name */}

                      {/* Title */}
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {message.title}
                      </Typography>

                      {/* Description with truncation */}
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="div"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 3, // Limit to 3 lines
                          WebkitBoxOrient: "vertical",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: message.message,
                        }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: isMobile ? "column" : "row", // Stack items on smaller screens
                          justifyContent: isMobile ? "center" : "space-between", // Adjust alignment
                          marginTop: "auto",
                        }}
                      >
                        <Typography
                          variant="caption"
                          color="textSecondary"
                          sx={{
                            fontSize: "16px",
                          }}
                        >
                          <b>Site: </b>
                          <span style={{ color: "#036185" }}>
                            {message.project?.name}
                          </span>
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "text.secondary",
                            fontStyle: "italic",
                          }}
                        >
                          {message.date &&
                            moment(message.date).format("MM-DD-yyyy")}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}

          {loading && (
            <Grid container spacing={2}>
              {Array.from({ length: 6 }).map((_, index) => (
                <Grid item xs={12} sm={6} lg={6} md={6} xl={4} key={index}>
                  <Card
                    sx={{
                      height: "100%",
                      padding: 2,
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Skeleton
                          variant="text"
                          width="100%"
                          height={30}
                          animation="wave"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Skeleton
                          variant="text"
                          width="40%"
                          height={20}
                          animation="wave"
                        />
                        <Box sx={{ marginTop: "auto" }}>
                          <Skeleton
                            variant="text"
                            width="40%"
                            height={20}
                            animation="wave"
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Skeleton
                          variant="text"
                          width="5"
                          height={40}
                          animation="wave"
                        />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}

          {!loading && messages && messages?.length === 0 && (
            <Box
              className="center"
              sx={{
                height: "100%",
              }}
            >
              <Typography variant="subtitle1">No Messages</Typography>
            </Box>
          )}
        </Box>
      </Paper>
      {messageOpen && (
        <CreateMessages
          drawerState={"view"}
          setIsOpenDrawer={setMessageOpen}
          isOpenDrawer={messageOpen}
          values={selectedMessage}
          fetchAlltasks={fetchMessages}
        />
      )}
    </>
  );
}
